// extracted by css-extract-rspack-plugin
export default {"scrollbarContainer":"---ui-next-src-components-Viewport-ImageScrollbar-module__scrollbarContainer-dumSAF","scrollbarInner":"---ui-next-src-components-Viewport-ImageScrollbar-module__scrollbarInner-cyB9zu","scrollbarInput":"---ui-next-src-components-Viewport-ImageScrollbar-module__scrollbarInput-bh8ySO"};
    if(module.hot) {
      (function() {
        var localsJsonString = "{\"scrollbarContainer\":\"---ui-next-src-components-Viewport-ImageScrollbar-module__scrollbarContainer-dumSAF\",\"scrollbarInner\":\"---ui-next-src-components-Viewport-ImageScrollbar-module__scrollbarInner-cyB9zu\",\"scrollbarInput\":\"---ui-next-src-components-Viewport-ImageScrollbar-module__scrollbarInput-bh8ySO\"}";
        // 1793759896101
        var cssReload = require("../../../../../node_modules/@rspack/core/dist/cssExtractHmr.js").cssReload(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  